module.exports = __webpack_public_path__ + "static/media/1.5b27134e.jpg";